<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 -2 10 10">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
</svg>
